import React from "react";
import { dateDMY } from "../../services/date.service";

const TableDataRender = ({
  data,
  columnMapping,
  scroll = true,
  tableRef = null,
  getRowClass,
  loading = false,
}) => {
  const renderColumns = () => {
    if (loading) {
      return (
        <tr className="text-center fw-bold">
          <td colSpan={Object.keys(columnMapping).length}>
            <div className="spinner-border spinner-border-sm me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            Cargando...
          </td>
        </tr>
      );
    }

    if (!data || data.length === 0) {
      return (
        <tr className="text-center fw-bold text-muted">
          <td colSpan={Object.keys(columnMapping).length} className="py-4">
            <i className="bi bi-inbox fs-1 d-block mb-2"></i>
            No se encontraron resultados
          </td>
        </tr>
      );
    }

    return data.map((item, index) => (
      <tr key={index} className={getRowClass ? getRowClass(item) : ""}>
        {Object.keys(columnMapping).map((columnKey) => (
          <td
            key={columnKey}
            className={`
              ${columnMapping[columnKey].nowrap ? "text-nowrap" : ""} 
              ${
                columnMapping[columnKey].align
                  ? `text-${columnMapping[columnKey].align}`
                  : "text-start"
              } 
              ${
                columnMapping[columnKey].color
                  ? `table-${columnMapping[columnKey].color}`
                  : ""
              }
              py-2 px-1 px-sm-2 px-md-3
              d-none d-sm-table-cell
              ${columnKey === Object.keys(columnMapping)[0] ? "d-table-cell" : ""}
              ${columnKey === Object.keys(columnMapping)[1] ? "d-table-cell" : ""}
            `}
          >
            <div className="d-block d-sm-none">
              <small className="text-muted fw-bold">
                {columnMapping[columnKey].header || columnKey}:
              </small>
            </div>
            <div 
              className="text-nowrap overflow-hidden" 
              style={{ textOverflow: 'ellipsis', maxWidth: '200px' }}
              title={
                columnMapping[columnKey].render
                  ? typeof columnMapping[columnKey].render(item) === 'string' 
                    ? columnMapping[columnKey].render(item) 
                    : ''
                  : columnMapping[columnKey].dataType === "date"
                  ? dateDMY(item[columnMapping[columnKey].key])
                  : item[columnMapping[columnKey].key]
              }
            >
              {columnMapping[columnKey].render
                ? columnMapping[columnKey].render(item)
                : columnMapping[columnKey].dataType === "date"
                ? dateDMY(item[columnMapping[columnKey].key])
                : item[columnMapping[columnKey].key]}
            </div>
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <div className="container-fluid px-0">
      {/* Vista de escritorio */}
      <div className="d-none d-md-block">
        <div
          className={
            scroll ? "table-responsive table-scroll" : "table-responsive"
          }
        >
          <table
            ref={tableRef}
            className="table table-hover table-striped table-light mb-0"
          >
            <thead className="table-dark sticky-top">
              <tr>
                {Object.keys(columnMapping).map((columnKey, index) => (
                  <th
                    className={`
                      ${columnMapping[columnKey].nowrap ? "text-nowrap" : ""} 
                      ${
                        columnMapping[columnKey].align
                          ? `text-${columnMapping[columnKey].align}`
                          : "text-start"
                      }
                      py-3 px-2 px-lg-3
                    `}
                    key={index}
                  >
                    {columnMapping[columnKey].header || columnKey}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{renderColumns()}</tbody>
          </table>
        </div>
      </div>

      {/* Vista de tablet */}
      <div className="d-none d-sm-block d-md-none">
        <div className="table-responsive">
          <table
            ref={tableRef}
            className="table table-hover table-striped table-light table-sm"
          >
            <thead className="table-secondary">
              <tr>
                {Object.keys(columnMapping).slice(0, 3).map((columnKey, index) => (
                  <th
                    className={`
                      text-nowrap
                      ${
                        columnMapping[columnKey].align
                          ? `text-${columnMapping[columnKey].align}`
                          : "text-start"
                      }
                      py-2 px-2
                    `}
                    key={index}
                  >
                    {columnMapping[columnKey].header || columnKey}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className={getRowClass ? getRowClass(item) : ""}>
                    {Object.keys(columnMapping).slice(0, 3).map((columnKey) => (
                      <td
                        key={columnKey}
                        className={`
                          ${
                            columnMapping[columnKey].align
                              ? `text-${columnMapping[columnKey].align}`
                              : "text-start"
                          } 
                          py-2 px-2 text-nowrap overflow-hidden
                        `}
                        style={{ textOverflow: 'ellipsis', maxWidth: '150px' }}
                        title={
                          columnMapping[columnKey].render
                            ? typeof columnMapping[columnKey].render(item) === 'string' 
                              ? columnMapping[columnKey].render(item) 
                              : ''
                            : columnMapping[columnKey].dataType === "date"
                            ? dateDMY(item[columnMapping[columnKey].key])
                            : item[columnMapping[columnKey].key]
                        }
                      >
                        {columnMapping[columnKey].render
                          ? columnMapping[columnKey].render(item)
                          : columnMapping[columnKey].dataType === "date"
                          ? dateDMY(item[columnMapping[columnKey].key])
                          : item[columnMapping[columnKey].key]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-4 text-muted">
                    No se encontraron resultados
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Vista móvil - Cards */}
      <div className="d-block d-sm-none">
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2 mb-0">Cargando...</p>
          </div>
        ) : !data || data.length === 0 ? (
          <div className="text-center py-5 text-muted">
            <i className="bi bi-inbox fs-1 d-block mb-3"></i>
            <p className="mb-0">No se encontraron resultados</p>
          </div>
        ) : (
          <div className="row g-2">
            {data.map((item, index) => (
              <div key={index} className="col-12">
                <div 
                  className={`
                    card border-0 shadow-sm h-100
                    ${getRowClass ? getRowClass(item) : ""}
                  `}
                >
                  <div className="card-body p-3">
                    {Object.keys(columnMapping).map((columnKey, idx) => (
                      <div 
                        key={columnKey} 
                        className={`
                          ${idx !== Object.keys(columnMapping).length - 1 ? "mb-2" : ""}
                          ${idx === 0 ? "border-bottom pb-2 mb-3" : ""}
                        `}
                      >
                        <div className="row align-items-center">
                          <div className="col-4">
                            <small className="text-muted fw-bold text-uppercase">
                              {columnMapping[columnKey].header || columnKey}
                            </small>
                          </div>
                          <div className="col-8">
                            <div 
                              className={`
                                text-nowrap overflow-hidden fw-normal
                                ${idx === 0 ? "fw-bold text-primary" : ""}
                                ${
                                  columnMapping[columnKey].align === "center"
                                    ? "text-center"
                                    : columnMapping[columnKey].align === "end"
                                    ? "text-end"
                                    : "text-start"
                                }
                              `}
                              style={{ textOverflow: 'ellipsis', maxWidth: '180px' }}
                              title={
                                columnMapping[columnKey].render
                                  ? typeof columnMapping[columnKey].render(item) === 'string' 
                                    ? columnMapping[columnKey].render(item) 
                                    : ''
                                  : columnMapping[columnKey].dataType === "date"
                                  ? dateDMY(item[columnMapping[columnKey].key])
                                  : item[columnMapping[columnKey].key]
                              }
                            >
                              {columnMapping[columnKey].render
                                ? columnMapping[columnKey].render(item)
                                : columnMapping[columnKey].dataType === "date"
                                ? dateDMY(item[columnMapping[columnKey].key])
                                : item[columnMapping[columnKey].key]}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableDataRender;